<div class="component-details">
  <fourd-component-header [expert]="expert()" [showExpertPhoneStatus]="true" (close)="onClose()"></fourd-component-header>
  <div class="component-column">
    <div class="login_header">
      <p>Log in now to access the great features of a {{config()?.BrandName}} account.</p>
    </div>
    <div [class]="formHelper?.validationSummaryCssClass()">
      <ul>
        @for (error of formHelper?.formErrorMessages(); track error) {
        <li>{{error}}</li>
        }
      </ul>
    </div>
    <div class="component-panel login_form" [formGroup]="loginForm">
      <div>
        <div class="label">
          <label for="loginEmail">
            {{moduleConfig?.FormFieldUsernameName}}
          </label>
        </div>
        <div class="input">
          <input [type]="moduleConfig?.FormFieldUsernameCanOnlyBeEmail ? 'email' : 'text'" id="loginEmail" formControlName="{{moduleConfig?.FormFieldUsernameName}}" (keyup)="onKeyUp($event)" />
        </div>
      </div>
      <div>
        <div class="label">
          <label for="loginPassword">
            Password
          </label>
        </div>
        <div class="input">
          <input type="password" id="loginPassword" formControlName="Password" (keyup)="onKeyUp($event)" />
        </div>
      </div>
      <div>
        <a [href]="moduleConfig?.UrlForgotPassword">Forgotten your password?</a>
      </div>
    </div>
    <div class="review-buttons">
      <a tabindex="0" class="component-button button-available review-button"
         [class.aspNetDisabled]="submittingData"
         (click)="loginRequest($event)">
        @if (!submittingData) {
        <span>Log in</span>
        }
        @if (submittingData) {
        <span><i><svg><use href="#icon-wait"></use></svg></i></span>
        }
      </a>
    </div>
    <div class="component-panel">
      <fourd-create-account [expert]="expert()" [productTypeIds]="productTypeIds()"></fourd-create-account>
    </div>
  </div>
  @if (modal) {
  <fourd-modal [modal]="modal"></fourd-modal>
  }
</div>
